import classNames from 'classnames'
import {SearchIcon} from '../../../icons'
import InputWithIcon from '../inputWithIcon'

const Searchbar = ({value, onChange, placeholder, isDarkMode}) => {
    return (
        <div className={classNames('search-actions', {
            dark: isDarkMode
        })}>
            <InputWithIcon
                placeholder={placeholder}
                icon={<SearchIcon />}
                onChange={onChange}
                value={value}
                type="text"
            />
        </div>
    )
}

export default Searchbar
